import React from "react";
import { variables as breakpoints } from "@xo-union/tk-ui-breakpoints";
import colors from "@xo-union/tk-ui-colors/lib/variables.css";
const styles = () => `
.Union__header-nav-pagelet-placeholder {
  background-color: ${colors.varBackgroundLight};
  border-bottom: 1px solid #ccc;
  display: flex;
  height: 60px;
}

@media (${breakpoints.inDesktop}) {
  .Union__header-nav-pagelet-placeholder {
    height: 120px;
  }
}
`;
export default (() => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", {
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML: {
    __html: styles()
  }
}), /*#__PURE__*/React.createElement("div", {
  className: "Union__header-nav-pagelet-placeholder"
})));